// extracted by mini-css-extract-plugin
module.exports = {"table":"deviations_table__3DNNK table_table__1cztV","header":"deviations_header__HZa6K table_table__1cztV"};